import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomersService } from '../../../../../services/customers.service';

interface Cliente {
  id: number | null;
  nombre: string;
}

@Component({
  selector: 'app-client-modal',
  templateUrl: './client-modal.component.html',
  styleUrls: ['./client-modal.component.scss']
})


export class ClientModalComponent{

  data: any = {};
  @Input() clientes: Cliente[] = [];



  @Input() visible: boolean = false;
  @Input() selectedClientId: number | null = null;

  @Output() onAccept = new EventEmitter<number | null>();
  @Output() onCancel = new EventEmitter<void>();

  constructor(
      private customersService: CustomersService,
    ) { }

  aceptar(): void {
    console.log("Cliente seleccionado:", this.selectedClientId)
    this.onAccept.emit(this.selectedClientId);
    this.visible = false;
  }

  cancelar(): void {
    this.onCancel.emit();
    this.visible = false;
  }

}
